import { render, staticRenderFns } from "./NewFullGradingInputComponent.vue?vue&type=template&id=972e2396&scoped=true"
import script from "./NewFullGradingInputComponent.vue?vue&type=script&lang=js"
export * from "./NewFullGradingInputComponent.vue?vue&type=script&lang=js"
import style0 from "./NewFullGradingInputComponent.vue?vue&type=style&index=0&id=972e2396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972e2396",
  null
  
)

export default component.exports